import { useEffect } from 'react'

const usePolling = (fn, interval) => {
  useEffect(() => {
    let id = undefined
    if (interval > 0) {
      id = setInterval(fn, interval)
    }
    return () => {
      if (id) {
        clearInterval(id)
      }
    }
  }, [fn, interval])
}

export default usePolling
